import MDivider from './Divider.vue';

export default MDivider;
